import { render, staticRenderFns } from "./TicketInterfaceWrapper.vue?vue&type=template&id=3936748a&scoped=true&"
import script from "./TicketInterfaceWrapper.vue?vue&type=script&lang=js&"
export * from "./TicketInterfaceWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TicketInterfaceWrapper.vue?vue&type=style&index=0&id=3936748a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3936748a",
  null
  
)

export default component.exports